import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

// Safe date helper - handles both Date objects and strings (Prisma can return either depending on environment)
export function toISO(d: any): string {
    if (!d) return new Date().toISOString();
    if (d instanceof Date) return d.toISOString();
    if (typeof d === 'string') return new Date(d).toISOString();
    return new Date().toISOString();
}

export function toISOOrEmpty(d: any): string {
    if (!d) return "";
    if (d instanceof Date) return d.toISOString();
    if (typeof d === 'string') return new Date(d).toISOString();
    return "";
}

export function toISOOrUndef(d: any): string | undefined {
    if (!d) return undefined;
    if (d instanceof Date) return d.toISOString();
    if (typeof d === 'string') return new Date(d).toISOString();
    return undefined;
}

/**
 * Formate intelligemment une chaîne de texte :
 * - Supprime les espaces inutiles (Trim)
 * - Première lettre de chaque mot en majuscule, le reste en minuscule
 * - Gère les noms composés séparés par des espaces, tirets ou apostrophes
 */
export function formatSmartCase(str: string | null | undefined): string {
    if (!str) return "";
    return str.trim().toLowerCase().replace(/(?:^|\s|-|\')\S/g, (a) => a.toUpperCase());
}
